import { Box } from "@mui/material";
import React, { useMemo } from "react";
import Message from "./message";
import { IMessage, MessageRole } from "./type";

interface IProps {
  messages: IMessage[];
  onRead: (message: IMessage) => void;
  onClick: (message: IMessage) => void;
}

export default function Messages(props: IProps) {
  const { messages, onRead, onClick } = props;

  const _messages = useMemo(() => {
    let res = [...messages].sort((a, b) => b.created_at.getTime() - a.created_at.getTime());
    const lastDeliveredIndex = res.findIndex((m) => m.statuses.filter((s)=>s.role !== "Client" && !!s.delivered_at).length > 0);
    const lastReadIndex = res.findIndex((m) => m.statuses.filter((s)=>s.role !== "Client" && !!s.read_at).length > 0);

    // Вважаємо що останній статус розповсюджується на всі попередні повідомлення, якщо вони від клієнта і не мають цього статусу
    res = res.map((m, i) => {
      if(m.role === MessageRole.Client){
        if((i >= lastDeliveredIndex && lastDeliveredIndex !== -1) || (i >= lastReadIndex && lastReadIndex !== -1)){
          const driverStatusIndex = m.statuses.findIndex((s)=>s.role !== MessageRole.Client);
          if(driverStatusIndex === -1){
            m.statuses.push({
              role: MessageRole.Driver,
              delivered_at: new Date().getTime(),
            })
          }else{
            m.statuses[driverStatusIndex].delivered_at = new Date().getTime();
          }
        }

        if(i >= lastReadIndex && lastReadIndex !== -1){
          const driverStatusIndex = m.statuses.findIndex((s)=>s.role !== MessageRole.Client);
          if(driverStatusIndex === -1){
            m.statuses.push({
              role: MessageRole.Driver,
              read_at: new Date().getTime(),
            })
          }else{
            m.statuses[driverStatusIndex].read_at = new Date().getTime();   
          }
        }
      }
      return {...m};
    })

    res = res.sort((a, b) => a.created_at.getTime() - b.created_at.getTime());
    return res;
  }, [messages]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        m: 1,
        gap: 1,
      }}
    >
      {_messages.map((message) => (
        <Message
          key={message.id || message.local_id}
          message={message}
          onRead={() => {
            onRead(message);
          }}
          onClick={!!message.point ? (() => {
            onClick(message)
          }) : undefined}
        />
      ))}
    </Box>
  )
}